export default "__VITE_ASSET__vzJHS78D__"